import type { Colour } from "$lib/utils/propTypes";
import { LanguageCode } from "$lib/gql/shopifygen/codegen";
import coloursEn from "./colours-en.json";
import coloursEs from "./colours-es.json";
import coloursFr from "./colours-fr.json";

export const getColourData = (locale: string) => {
  let colours: { [key: string]: Colour };

  switch (locale) {
    case LanguageCode.En:
      colours = coloursEn;
      break;
    case LanguageCode.Es:
      colours = coloursEs;
      break;
    case LanguageCode.Fr:
      colours = coloursFr;
      break;
    default:
      colours = coloursEn;
      break;
  }
  return colours;
};
